/**
 * 
 * key
 * 
 */


const key = 'YmFua19hY2NvdW50'

export default key 